"use client"

import React, { useMemo } from "react"
import { useOddsView } from "contexts"
import formatToFixed from "../../helpers/formatters/formatToFixed"

type OddsValueProps = {
  className?: string
  odds: string | number
  section?: string
}

const OddsValue: React.FC<OddsValueProps> = ({ className, odds, section }) => {
  const { oddsView, formatViewValue } = useOddsView()

  const formattedValue = useMemo(() => {
    if (!odds) {
      return "-"
    }
    if (section === "topEvents") {
      return formatToFixed(String(odds), 2)
    }
    return formatViewValue(odds)
  }, [oddsView, odds])

  return <div className={className}>{formattedValue}</div>
}

export default OddsValue
